module.exports = __webpack_public_path__ + "img/3.5fd96e64.jpg";